import React from 'react';
import Label from 'components/_utility/Label';
import { Wrap, Heading, GoBack } from './ErrorBoundary.styled';
import ArrowLeft from './assets/icons/chevron-left.svg';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  // static getDerivedStateFromError(error) {
  //   return { hasError: true };
  // }

  // componentDidCatch(error, errorInfo) {
  //   console.error(error, errorInfo); // eslint-disable-line
  // }

  render() {
    const { hasError } = this.state;
    const { children, error } = this.props;

    // if (hasError || error) {
    //   return (
    //     <Wrap>
    //       <Heading>
    //         <Label name="genericErrorTitle" />
    //       </Heading>
    //       <GoBack href="/" onClick={() => window.history.back()}>
    //         <ArrowLeft /> <Label name="backLabel" />
    //       </GoBack>
    //     </Wrap>
    //   );
    // }

    return children;
  }
}

export default ErrorBoundary;
